import { iToastMessage } from "./types";
import { StyledTitle } from "./typography";

export const MessageToast = ({ message }: iToastMessage) => {
  return (
    <StyledTitle tag="heading4" titleStyle="heading4" color="#F8F9FA">
      {message}
    </StyledTitle>
  );
};
